<ng-container *ngIf="!errorType">
  <div *ngIf="!loaded" class="loader">
    <loader-overlay [darkOnly]="previewMode === 'popup'" [styles]="{ backgroundColor: 'transparent', backdropFilter: 'none' }">
    </loader-overlay>
  </div>
  <div [style]="{ opacity: showProgressBar ? '1' : '0' }" class="loading-progress-container">
    <ng-container *ngIf="!progressPercentages">
      <ng-container *ngTemplateOutlet="loadingMessage; context: { text: 'Preparing', dynamicEllipsis: true }"></ng-container>
    </ng-container>
    <ng-container *ngIf="progressPercentages > 0 && progressPercentages < 100">
      <ng-container *ngTemplateOutlet="loadingMessage; context: { text: progressPercentages + '%', dynamicEllipsis: false }"></ng-container>
    </ng-container>
    <ng-container *ngIf="progressPercentages === 100">
      <ng-container *ngTemplateOutlet="loadingMessage; context: { text: 'Rendering', dynamicEllipsis: true }"></ng-container>
    </ng-container>
    <div #loadingRef class="loading-progress"></div>
  </div>

  <div class="pdf-view-container">
    <div
      #viewPort
      class="preview-item viewport"
      [style]="{ marginTop: previewMode !== 'popup' ? '60px' : '0' }"
      id="viewport"
      role="main"
    ></div>
  </div>
</ng-container>
<ng-container *ngIf="errorType">
  <error-preview
    [errorType]="errorType"
    [previewMode]="previewMode"
    [icon]="model.icon"
    (reload)="reload.emit()"
    (download)="download.emit()"
    (open)="open.emit()"
  >
  </error-preview>
</ng-container>

<ng-template #loadingMessage let-text="text" let-dynamicEllipsis="dynamicEllipsis">
  <div class="loading-progress-text" [ngClass]="{ popup: previewMode === 'popup' }">
    <span>{{ text }}</span>
    <dynamic-ellipsis *ngIf="dynamicEllipsis"></dynamic-ellipsis>
  </div>
</ng-template>
